package com.wintermar.inspection.core.ui.theme.color.palette.accent

import androidx.compose.ui.graphics.Color
import com.wintermar.inspection.core.ui.theme.color.model.ColorVariant

val YellowColorVariant = ColorVariant(
    n100 = Color(0xFFFFF7D6),
    n200 = Color(0xFFF8E6A0),
    n300 = Color(0xFFF5CD47),
    n400 = Color(0xFFE2B203),
    n500 = Color(0xFFCF9F02),
    n600 = Color(0xFFB38600),
    n700 = Color(0xFF946F00),
    n800 = Color(0xFF7F5F01),
    n900 = Color(0xFF533F04),
    n1000 = Color(0xFF332E1B)
)
